import React from "react";
import AdminLayout from "./AdminLayout";
import AdsManagement from "../../components/Admin/AdsManagement";

const AdsPage = () => {
  return (
    <AdminLayout>
      <AdsManagement />
    </AdminLayout>
  );
};

export default AdsPage;
